export default [
  {
    title: 'User Management',
    icon: 'UsersIcon',
    tagVariant: 'light-warning',
    route: 'user-management'
  },
]  